// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"5a475e55","453":"03b51530","600":"4e11a739"}[chunkId] + ".chunk.js";
};